import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/logarithm-calculator',
  component: () => import('../../routes/LogarithmCalculator.svelte'),
  card: {
    id: 'logarithm-calculator',
    title: 'Logarithm Calculator',
    description: 'Calculate logarithms with any base — natural log (ln), common log (log₁₀), binary log (log₂), or custom base. Includes antilog and equivalent base conversions.',
    icon: 'functions',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/logarithm-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Logarithm Calculator – Free log, ln, log₁₀, log₂ Calculator',
    description: 'Free logarithm calculator. Calculate log base b of x, natural log (ln), common log (log₁₀), binary log (log₂), and antilog. Includes change-of-base formula and equivalent conversions.',
  },
};

export default meta;
